import { formValueSelector } from 'redux-form';
import { BAGGAGE_VALUES } from '../../common/utils/baggageUtils';
import { SECOND_BAGGAGE, CHECK_IN_BAGGAGE } from '../../../products';
const checkinBaggageFormSection = CHECK_IN_BAGGAGE.name;
const secondBagFormSection = SECOND_BAGGAGE.name;
const getTravelersSelection = ({
  state,
  form,
  formSection,
  valueWhenSelected
}) => {
  var _Object$values;
  const formData = formValueSelector(form)(state, formSection);
  const selectionTravelerNumberOfUnits = (_Object$values = Object.values(formData || {})) === null || _Object$values === void 0 || (_Object$values = _Object$values.filter(value => (value === null || value === void 0 ? void 0 : value.value) && String(value.value) === valueWhenSelected)) === null || _Object$values === void 0 ? void 0 : _Object$values.map(({
    id
  }) => ({
    travelerId: String(id),
    numberOfUnits: 1
  }));
  if (selectionTravelerNumberOfUnits.length === 0) {
    return null;
  }
  return selectionTravelerNumberOfUnits;
};
const getSelectionTravelerNumberOfUnits = ({
  state,
  form
}) => {
  const secondBagWhenFirstIncluded = getTravelersSelection({
    state,
    form,
    formSection: secondBagFormSection,
    valueWhenSelected: BAGGAGE_VALUES.TRUE
  });
  const secondBagWhenFirstPurchasable = getTravelersSelection({
    state,
    form,
    formSection: checkinBaggageFormSection,
    valueWhenSelected: BAGGAGE_VALUES.COMBINED
  });
  const selectionTravelerNumberOfUnits = secondBagWhenFirstIncluded || secondBagWhenFirstPurchasable;
  if (!selectionTravelerNumberOfUnits) {
    return null;
  }
  return selectionTravelerNumberOfUnits;
};
export const getGraphQlSelection = ({
  state,
  form
}) => {
  const selectionTravelerNumberOfUnits = getSelectionTravelerNumberOfUnits({
    state,
    form
  });
  if (!selectionTravelerNumberOfUnits) {
    return null;
  }
  return {
    productId: String(SECOND_BAGGAGE.id),
    selectionTravelerNumberOfUnits
  };
};
//# sourceMappingURL=getGraphQlSelection.js.map